import React, { FC } from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';
import { DotsSixVertical } from '@phosphor-icons/react';
import styles from './WorkoutBuilderModal.module.scss';

export interface DraggableExerciseRowProps {
  exLocalId: string;
  blockLocalId: string;
  isOver: boolean;
  children: (handle: React.ReactNode, isDragging: boolean) => React.ReactNode;
}

const DraggableExerciseRow: FC<DraggableExerciseRowProps> = ({
  exLocalId,
  blockLocalId,
  isOver,
  children,
}) => {
  const { attributes, listeners, setNodeRef: setDragRef, isDragging } = useDraggable({
    id: exLocalId,
    data: { blockLocalId },
  });
  const { setNodeRef: setDropRef, isOver: isDropOver } = useDroppable({
    id: `drop-${exLocalId}`,
    data: { exLocalId, blockLocalId },
  });

  const setRef = (node: HTMLElement | null) => {
    setDragRef(node);
    setDropRef(node);
  };

  const highlight = isOver || isDropOver;

  const handle = (
    <div
      {...attributes}
      {...listeners}
      className={styles.dragHandle}
      title="Trascina su un altro esercizio per creare un superset"
    >
      <DotsSixVertical size={14} weight="bold" />
    </div>
  );

  return (
    <div
      ref={setRef}
      className={`${styles.dragContainer}${highlight ? ` ${styles.dragHighlight}` : ''}`}
      style={{ opacity: isDragging ? 0.4 : 1 }}
    >
      {children(handle, isDragging)}
    </div>
  );
};

export default DraggableExerciseRow;
